import { FileMetaData } from '../../../../../../../data/models'

export enum InvoiceFormat {
  XRECHN_CII = 0,
  XRECHN_UBL_Invoice = 1,
  XRECHN_UBL_CreditNote = 2,
  ZUGFeRD_EN16931 = 3,
  ZUGFeRD_EXTENDED = 4,
  ZUGFeRD_BASIC = 5,
  ZUGFeRD_MINIMUM = 6,
}

export enum InvoiceFormatString {
  XRECHN_CII = 'XRechnung CII',
  XRECHN_UBL_Invoice = 'XRechnung UBL Invoice',
  XRECHN_UBL_CreditNote = 'XRechnung UBL Credit Note',
  ZUGFeRD_EN16931 = 'ZUGFeRD EN16931',
  ZUGFeRD_EXTENDED = 'ZUGFeRD Extended',
  ZUGFeRD_BASIC = 'ZUGFeRD Basic',
  ZUGFeRD_MINIMUM = 'ZUGFeRD Minimum',
}

export const getInvoiceFormatFromError = (format?: number | null): string => {
  if (format === null || format === undefined) return ''

  // Map that handles numeric enum values from errors
  const numericMap: Record<number, string> = {
    [InvoiceFormat.XRECHN_CII]: InvoiceFormatString.XRECHN_CII,
    [InvoiceFormat.XRECHN_UBL_Invoice]: InvoiceFormatString.XRECHN_UBL_Invoice,
    [InvoiceFormat.XRECHN_UBL_CreditNote]:
      InvoiceFormatString.XRECHN_UBL_CreditNote,
    [InvoiceFormat.ZUGFeRD_EN16931]: InvoiceFormatString.ZUGFeRD_EN16931,
    [InvoiceFormat.ZUGFeRD_EXTENDED]: InvoiceFormatString.ZUGFeRD_EXTENDED,
    [InvoiceFormat.ZUGFeRD_BASIC]: InvoiceFormatString.ZUGFeRD_BASIC,
    [InvoiceFormat.ZUGFeRD_MINIMUM]: InvoiceFormatString.ZUGFeRD_MINIMUM,
  }

  return numericMap[format]
}

export const getInvoiceFormatFromEInvoice = (
  format?: FileMetaData['subType'] | null,
): string => {
  if (format === null || format === undefined) return ''

  // Typed map for string values from eInvoice - forces all FileMetaData['subType'] values
  const stringMap: Record<FileMetaData['subType'], string> = {
    XRECHN_CII: InvoiceFormatString.XRECHN_CII,
    XRECHN_UBL_Invoice: InvoiceFormatString.XRECHN_UBL_Invoice,
    XRECHN_UBL_CreditNote: InvoiceFormatString.XRECHN_UBL_CreditNote,
    ZUGFeRD_EN16931: InvoiceFormatString.ZUGFeRD_EN16931,
    ZUGFeRD_EXTENDED: InvoiceFormatString.ZUGFeRD_EXTENDED,
    ZUGFeRD_BASIC: InvoiceFormatString.ZUGFeRD_BASIC,
    ZUGFeRD_MINIMUM: InvoiceFormatString.ZUGFeRD_MINIMUM,
  }

  return stringMap[format]
}
